import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Icon from '../../../common/containers/icon';
const TextControls = _ref => {
  let editing = _ref.editing,
    text = _ref.text,
    onChange = _ref.onChange,
    onSave = _ref.onSave,
    _ref$hoverStyle = _ref.hoverStyle,
    hoverStyle = _ref$hoverStyle === void 0 ? {} : _ref$hoverStyle,
    onEdit = _ref.onEdit,
    onAdd = _ref.onAdd,
    onRemove = _ref.onRemove;
  return /*#__PURE__*/React.createElement("span", null,
  // if we are editing, display an input.  else, just the text.
  editing ? /*#__PURE__*/React.createElement("input", {
    value: text,
    onChange: onChange,
    onBlur: onSave
  }) : /*#__PURE__*/React.createElement("span", {
    style: hoverStyle
  }, text),
  // if we are editing, display the save button.  else display other controls.
  editing ? /*#__PURE__*/React.createElement(Button
  /* eslint-disable react/jsx-indent-props */, {
    size: "sm",
    onClick: onSave,
    className: "t-tn-button-save"
    /* eslint-enable react/jsx-indent-props */
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "save"
  }), " Save") : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: onEdit,
    className: "t-tn-button-edit"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "pencil-alt"
  }), " Edit"), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: onAdd,
    className: "t-tn-button-new-child"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " New Child Tag"), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: onRemove,
    className: "t-tn-button-delete"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "times"
  }), " Delete Tag")));
};
TextControls.propTypes = {
  editing: PropTypes.bool.isRequired,
  hoverStyle: PropTypes.shape({}),
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
export default TextControls;